import { InjectionToken, Type } from '@angular/core';
import { AppAuthConfig, LoginMethod } from './auth.types';
import { FormControl, FormGroup } from '@angular/forms';

export const APP_AUTH_CONFIG = new InjectionToken<AppAuthConfig>('APP_AUTH_CONFIG');

export const AUTH_WIDGETS = new InjectionToken<Record<LoginMethod, Type<any>>>('AUTH_WIDGETS');

export interface AuthWidgetContext {
    form: FormControl;
    registerPayloadBuilder(builder: () => any): void;
}
export const AUTH_WIDGET_CONTEXT = new InjectionToken<AuthWidgetContext>('AUTH_WIDGET_CONTEXT');